/** dash.naturenix.jp へのデバイス深リンク（support コンソールと別オリジン） */

export const DASH_BASE_URL = "https://dash.naturenix.jp";

export function dashMacUrl(mac: string): string {
  return `${DASH_BASE_URL}/?mac=${encodeURIComponent(mac.trim())}`;
}

export function openDashMac(mac: string): void {
  const m = (mac || "").trim();
  if (!m) return;
  window.open(dashMacUrl(m), "_blank", "noopener");
}
